import { render, staticRenderFns } from "./RondasIcon.vue?vue&type=template&id=0efa161c"
import script from "./RondasIcon.vue?vue&type=script&lang=js"
export * from "./RondasIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports